<template>
  <div class="advisory-future-questions padding-bottom-ml">
    <div class="content">
      <div class="padding-horizontal-ml">
        <advisory-top-header @close="close" @back=back variant="beige"/>
        <Stepper :current-step="stepperFiller" :total-steps="flowStepsNumber"/>
        <div class="ri-title margin-top-ml margin-bottom-sm">2 שאלות קטנות ונצא לדרך.</div>
        <div class="ri-small-display margin-top-ml margin-bottom-l ri-alte-bold">עד כמה העתיד שלך מתוכנן?</div>
        <div
          :class="['answer margin-bottom-s padding-right-m',
          { selected: selectedAnswers.future && selectedAnswers.future.number === answer.number }]"
          v-for="answer of answers"
          @click="() => select(answer)"
          :key="answer.number">
          {{ answer.text }}
        </div>
      </div>
    </div>
    <div class="padding-horizontal-ml">
      <riseup-button :action="next"
                     :size="'slim'"
                     title="להמשיך"
                     :disabled="!hasAnswer"
                     :variant="'primary'"/>
    </div>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import Segment from '@/Segment';
import AdvisoryMixin from '@/mixins/AdvisoryMixin.vue';
import AdvisoryTopHeader from './AdvisoryTopHeader';

export default {
  name: 'AdvisoryFutureQuestions',
  components: {
    AdvisoryTopHeader,
    RiseupButton: BaseUI.RiseupButton,
    Stepper: BaseUI.Stepper,
  },
  mixins: [AdvisoryMixin],
  props: {
    stepperFiller: {
      type: Number,
      default: 7,
    },
  },
  created() {
    Segment.trackUserGot('AdvisoryFutureQuestions');
  },
  methods: {
    ...mapActions('advisory', ['setFutureAnswer']),
    next() {
      this.$emit('next');
    },
    back() {
      this.$emit('back');
    },
    close() {
      this.$emit('close');
    },
    select(answer) {
      this.setFutureAnswer(answer);
      Segment.trackUserInteraction('AdvisoryFutureQuestions__Answered', { answer });
    },
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    ...mapGetters('advisory', ['selectedAnswers']),
    answers() {
      return [{
        number: 1,
        text: 'יש לי תוכנית ברורה, אני על המסלול הנכון',
      },
      {
        number: 2,
        text: 'ככה ככה, לא ברור לי איך להגיע למטרות שלי',
      },
      {
        number: 3,
        text: 'בכלל לא, אין לי מטרות ולא תוכנית ברורה',
      }];
    },
    hasAnswer() {
      return this.selectedAnswers.future?.number;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.advisory-future-questions {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: $riseup_beige;

  .content {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    text-align: start;

    .answer {
      display: flex;
      align-items: center;
      height: 76px;
      border-radius: 12px;
      text-align: start;
      border: 1px solid #D6D4D2;
      cursor: pointer;

      &.selected {
        color: $riseup_blue;
        border: 1px solid $riseup_blue;
        font-weight: bold;
      }
    }
  }
}
</style>
